module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "p-contact"
  }, [_c('div', {
    staticClass: "p-contact__container u-marg-x-auto u-w8of10"
  }, [_c('h1', [_c('span', {
    staticClass: "t-text--xxl t-ffamily--domaine t-fweight--light",
    domProps: {
      "innerHTML": _vm._s(_vm.content.page_title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-marg-t-xxl u-flex u-flex-jc--space-between u-flex-fd--column@sm"
  }, [_c('div', {
    staticClass: "u-w3of8 u-fit-w@xs"
  }, [_c('p', {
    staticClass: "p-contact__container__content t-text--sm t-lspacing--xxxs t-ffamily--domaine t-fweight--light",
    domProps: {
      "innerHTML": _vm._s(_vm.content.content)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-marg-t-xl@sm u-flex u-flex-fw--wrap u-flex-fd--column@xs u-w4of8 u-fit-w@xs"
  }, _vm._l((_vm.content.list), function(item, index) {
    return _c('div', {
      staticClass: "p-contact__container__list-item u-w1of2 u-fit-w@xs u-marg-t-sm"
    }, [_c('h4', [_c('span', {
      staticClass: "t-text--xxs-ls u-uppercase",
      domProps: {
        "innerHTML": _vm._s(item.label)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "u-marg-t-xs"
    }, [(item.name && item.name.trim() !== '') ? _c('div', [_c('span', {
      staticClass: "t-text--xs u-opacity--40",
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    })]) : _vm._e(), _vm._v(" "), (item.mail && item.mail.trim() !== '') ? _c('div', {
      staticClass: "p-contact__container__list-item__item",
      class: [item.name && item.name.trim() !== '' ? 'has-item-upwards' : '']
    }, [_c('a', {
      staticClass: "u-relative t-link u-click-area-xxxs",
      attrs: {
        "href": 'mailto:' + item.mail,
        "target": "_blank",
        "rel": "noopener"
      }
    }, [_c('span', {
      staticClass: "t-text--xs u-opacity--40",
      domProps: {
        "innerHTML": _vm._s(item.mail)
      }
    })])]) : _vm._e(), _vm._v(" "), (item.phone && item.phone.trim() !== '') ? _c('div', {
      staticClass: "p-contact__container__list-item__item",
      class: [(item.name && item.name.trim() !== '') || (item.mail && item.mail.trim() !== '') ? 'has-item-upwards' : '']
    }, [_c('a', {
      staticClass: "u-relative t-link u-click-area-xxxs",
      attrs: {
        "href": 'tel:' + item.phone,
        "target": "_blank",
        "rel": "noopener"
      }
    }, [_c('span', {
      staticClass: "t-text--xs u-opacity--40",
      domProps: {
        "innerHTML": _vm._s(item.phone)
      }
    })])]) : _vm._e()])])
  }))])]), _vm._v(" "), _c('app-page-footer', {
    attrs: {
      "text": _vm.content.footer_text_content,
      "page": _vm.content.footer_page,
      "link-label": _vm.content.footer_link_label
    }
  }), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c9de214"}!./src/scripts/components/page-contact/template.html
// module id = 193
// module chunks = 0